export enum ForbiddenWordType {
  block = 1,
  score,
}
